import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { BookingService } from './../../booking/models/booking.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { SelectVehiclePopupComponent } from './select-vehicle-popup.component';
import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { WeGoConfig, ApplicationRouteURL, IKeyValueInterface, DataListModel } from './../../shared/config';
import { SpecialBookingModel } from './../models/special-booking.model';
import { AuthService } from './../../shared/models/auth.service';
import { OrganizationDropDownModel } from '../../organization/models/organization.model';
import { DropdownModel } from '../../report/models/report-filter-cost-center.model';

const moment = require("moment");
@Component({
  selector: 'wego-special-booking',
  template: require('../views/special-booking.component.html'),
  providers: [BookingService, TranslateService],
  styles: [`
          .box-body{
            padding: 0px 10px 10px;
          }
          .checkbox-inline{
            padding-left: 0px !important;
          }
          .box-body{
            padding:10px 10px 10px 10px;
          }
          .search
          {
            margin-top:5px;
          }
          `
  ]
})
export class SpecialBookingComponent implements OnInit {
  @ViewChild('childModal') public childModal: any;
  @ViewChild('successPopup') public successPopup: any;

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  flatPickrConfigEnd: FlatPickrModel;
  model: SpecialBookingModel;
  searchModel: SpecialBookingModel;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  availableModel: any;
  specialBookingTypeList: any;
  DataListModel: DataListModel;
  affectedBookingList: any;
  affectedBookingMasterHashId: string;
  confirmMessage: string;
  message: string;
  isInit: boolean = true;
  private popupMsg: string;
  private module: string;
  urlDefaultPage: string;
  isConfirmBooking: boolean = true;
  isLoading: boolean;
  VehicleCompanyHashId: any;
  organizationList: OrganizationDropDownModel[];
  sharedVehicleGroupList: DropdownModel[];

  constructor(private bookigService: BookingService,
    private translate: TranslateService, private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.module = this.translate.instant('LblSpecialBooking');
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.initiateModel();
  }

  private initiateModel() {
    this.specialBookingTypeList = [
      {
        Key: 'MAINTENANCE',//this.translate.instant('LblMaintenance'),
        Value: 'MAINTENANCE'
      },
      {
        Key: 'UNAVAILABLE',//this.translate.instant('LblUNAVAILABLE'),
        Value: 'UNAVAILABLE'
      }
    ];
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigEnd = this.SetDefaultFlatPickrConfig();
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["bookingReferenceID", "driverName"];
    this.model = new SpecialBookingModel();
    // this.model.startDateTime = moment().add('m', 5).format('DD-MM-YYYY HH:mm');
    // this.model.endDateTime = moment().add('H', 1).add('m', 5).format('DD-MM-YYYY HH:mm');
    this.model.specialBookingType = this.specialBookingTypeList[0].Value;
    this.searchModel = new SpecialBookingModel();
    console.log(this.DataListModel);
  }

  public ResetPage() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["bookingReferenceID", "driverName"];
    this.model = new SpecialBookingModel();
    // this.model.startDateTime = moment().add('m', 5).format('DD-MM-YYYY HH:mm');
    // this.model.endDateTime = moment().add('H', 1).add('m', 5).format('DD-MM-YYYY HH:mm');
    this.model.specialBookingType = this.specialBookingTypeList[0].Value;
    this.searchModel = new SpecialBookingModel();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  onChangeSelectedBT(selectedField: any) {
    this.model.specialBookingType = selectedField;
    console.log(this.model.specialBookingType);
  }

  OnConfirmBooking($event: any) {
    this.ShowChildModal();
  }

  private OnSearch(forms: any) {
    console.log(this.model);
    this.DataListModel.currentPage = 0;
    Object.assign(this.searchModel, this.model);
    console.log(this.DataListModel);
    this.GetAffectedBookings();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAffectedBookings();
  }
  private OnSearchAffectedBooking(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 0;
    Object.assign(this.searchModel, this.model);
    this.GetAffectedBookings();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAffectedBookings();
  };

  public ShowChildModal(): void {
    if (this.affectedBookingList != undefined) {
      this.confirmMessage = this.translate.instant('LblSpecialBookingConfiramtionmsg');;
      this.childModal.show();
    }
  }

  public HideChildModal(): void {
    this.affectedBookingMasterHashId = "";
    this.model.adminRemarks = null;
    this.model.isConfirmed = false;
    this.isInit = true;
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    this.childModal.hide();
  }

  public MakeSpecialBooking() {
    this.bookigService.MakeSpecialBooking(this.model)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.DataListModel.currentPage = 1;
            this.HideChildModal();
            this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);
            this.ShowSuccessPopup();
          }
          else {
            this.errorModel = res.error;
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        });
  }

  private SuccessSelectVehicleModal($event: any) {
    this.model.vehicleHashId = $event.VehicleMasterHashID;
    this.model.licenceTag = $event.LicenceTage;
    this.VehicleCompanyHashId = $event.OwnerCompanyHashId;
    console.log(this.model);
    console.log($event);
  }



  private SuccessSelectDriverModal($event: any) {
    this.model.driverHashId = $event.DriverHashID;
    this.model.driverName = $event.DriverName;
    this.GetSharedVehicleGroupList();
  }


  private GetSharedVehicleGroupList() {
    this.bookigService.GetSharedVehicleGroupListForSpecialBooking(this.model.driverHashId, this.VehicleCompanyHashId).subscribe(
      res => {
        this.sharedVehicleGroupList = res.data;
        if (
          this.sharedVehicleGroupList &&
          this.sharedVehicleGroupList.length == 1
        ) {
          this.model.sharedVehicleGroupHashID = this.sharedVehicleGroupList[0].keyHash;
          this.GetOrganizationList();
        } else {
          this.model.sharedVehicleGroupHashID = '';
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private OnSharedVehicleGroupChange() {
    this.GetOrganizationList();
  }

  private GetOrganizationList() {
    this.bookigService.GetOrganizationList(this.model.driverHashId, this.model.sharedVehicleGroupHashID).subscribe(
      res => {
        this.organizationList = res.data;
        if (
          this.organizationList &&
          this.organizationList.length == 1
        ) {
          this.model.organizationHashID = this.organizationList[0].organizationMasterHashId;
        } else {
          this.model.organizationHashID = '';
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private GetAffectedBookings() {
    this.isLoading = true;
    this.bookigService.GetAffectedBookingList(this.searchModel, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (!res.data) {
            this.errorModel = res.error;
            this.isLoading = false;
          }
          else {
            this.errorModel = null;
            this.affectedBookingList = res.data;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isInit = false;
            this.isConfirmBooking = res.status.isSpecialBookingExist ? false : true;
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  onSubmit(forms: any) {
    let cancelAffectedBookingList: any[];
    cancelAffectedBookingList = this.affectedBookingList.map((x: any) => x.bookingMasterHashId);
    this.model.affectedBookingList = cancelAffectedBookingList;
    this.model.isConfirmed = true;
    this.MakeSpecialBooking();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.ResetPage();
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-special/components/special-booking.component.ts